<template>
  <div class="vx-row mb-6 input-field">
    <div class="vx-col sm:w-1/3 w-full label-section" v-if="title">
      <span>{{ title }}</span>
      <span class="input-field-required" v-show="required"> *</span>
    </div>
    <div class="vx-col w-full input-section" :class="title ? 'sm:w-2/3' : ''">
      <ValidationProvider
        :name="fieldName || title"
        :rules="validate"
        v-slot="{ errors }"
      >
        <div :class="errors.length > 0 ? 'input-field-input-error' : null">
          <v-select
            :id="id"
            :options="options"
            v-model="dataValue"
            :label="optionsLabel"
            :reduce="optionsReduce"
            :placeholder="placeholder"
            :disabled="disabled"
            v-if="type === 'select'"
          />
          <vs-textarea
            :id="id"
            :type="type"
            class="input-field-input"
            v-model="dataValue"
            :danger="errors.length > 0"
            val-icon-pack="feather"
            val-icon-danger="icon-alert-circle"
            :placeholder="placeholder"
            :disabled="disabled"
            :rows="rows"
            v-else-if="type === 'textarea'"
          />
          <vs-checkbox
            :id="id"
            class="input-field-input"
            v-model="dataValue"
            :danger="errors.length > 0"
            val-icon-pack="feather"
            val-icon-danger="icon-alert-circle"
            color="secondary"
            :disabled="disabled"
            v-else-if="type === 'boolean'"
          />
          <vs-input
            :id="id"
            :type="type"
            class="input-field-input"
            v-model="dataValue"
            :danger="errors.length > 0"
            val-icon-pack="feather"
            val-icon-danger="icon-alert-circle"
            :placeholder="placeholder"
            :disabled="disabled"
            v-else
          />
        </div>
        <span
          class="text-danger text-sm validation-error-text"
          v-if="errors[0]"
        >
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  name: 'input-field',
  components: {
    ValidationProvider,
    vSelect
  },
  props: {
    value: {
      require: true
    },
    id: {
      require: true,
      type: String
    },
    title: {
      require: true,
      type: String
    },
    required: {
      require: true,
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return (
          ['text', 'number', 'textarea', 'select', 'boolean', 'date', 'time'].indexOf(value) !==
          -1
        )
      }
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
    optionsLabel: {
      type: String,
      default: 'id'
    },
    optionsReduce: {
      type: Function
    },
    placeholder: {
      type: String
    },
    rows: {
      type: Number,
      default: 4
    },
    fieldName: {
      type: String
    }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    validate() {
      const rules = [this.required ? 'required' : '', this.rules]
      return rules.join('|')
    }
  },
  methods: {
    calculateDropdownPosition(dropdownList, _component, { width, top, left }) {
      dropdownList.style.top = top
      dropdownList.style.left = left
      dropdownList.style.width = width
      dropdownList.style.zIndex = 53001
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables.scss';

.input-field {
  .input-field-required {
    color: #db2828;
  }
  .text-error {
    font-size: 1.2rem;
  }
  .input-field-input {
    width: 100%;
    background-color: #fff;

    textarea[disabled] {
      background-color: rgba(239, 239, 239, 0.3);
      opacity: 0.5;
      cursor: default;
      pointer-events: none;
    }
  }
  .input-field-input-error .vs-inputx {
    border: 1px solid #ca3b33 !important;
  }

  .input-field-input-error .input-field-input {
    border: 1px solid #ca3b33 !important;
  }

  .input-field-input-error .vs__dropdown-toggle {
    border: 1px solid #ca3b33;
  }
  .input-icon-validate-danger .input-icon-validate {
    background: none;
  }

  .con-text-validation {
    height: 0 !important;
  }

  .validation-error-text {
    color: #db2828;
    top: 0.5rem;
    position: relative;
  }

  .vs__dropdown-menu {
    width: 100% !important;

    .vs__dropdown-option:hover,
    .vs__dropdown-option--highlight {
      background: $primary !important;
    }
  }
}
</style>
